import axios from 'axios'

class BlockDataService {
  async fetchBlockData (report, blockKey, displayKey, stratifyBy, filters = {}, sliderKey, dataKey) {
    const response = await axios.get(`api/report/${report.id}/block-data/${blockKey}`, {
      params: {
        version: report.version,
        parentVersion: report.parent.version,
        dataset: displayKey,
        strata: stratifyBy,
        filters: Object.keys(filters).length > 0 ? filters : undefined,
        slider: sliderKey,
        dataKey
      }
    })
    return this.transformBlockData(response.data)
  }

  async fetchReferenceData ({ region, regionLevel, subgroup }) {
    const response = await axios.get(`api/report/reference-data`, {
      params: {
        type: 'geo',
        region,
        regionLevel,
        subgroup
      }
    })
    return this.transformBlockData(response.data)
  }

  /**
   * Transform from block data api output to an array of objects with named properties
   * @param {array[]} data
   */
  transformBlockData (data = []) {
    if (data.length < 1) return data

    if (Array.isArray(data[0])) {
      const headers = data.shift()
      data = data.map((r) => {
        return headers.reduce((transformed, h, i) => ({ ...transformed, [h]: r[i] }), {})
      })
    }
    return data
  }

  transformRefData (data) {
    const transformedData = {}

    data.reduce((acc, { subgroupValue, region, value }) => {
      acc[subgroupValue] = acc[subgroupValue] || {}
      acc[subgroupValue][region] = value
      return acc
    }, transformedData)

    return transformedData
  }

  filterBlockDataByKeyValue (data, key, value) {
    let filteredData = data.slice()

    if (key) {
      filteredData = filteredData.filter((data) => {
        // Handle cases where the number is saved as a string
        const compareValue = (typeof data[key] === 'string') ? value.toString() : value
        return (data[key] === compareValue)
      })
    }

    return filteredData
  }

  filterBlockDataByRefData (data, regionField, referenceData, thresholdField, thresholdValue) {
    return data.filter((row) => {
      const region = row[regionField]
      return referenceData[thresholdField][region] >= thresholdValue
    })
  }
}

export const blockDataService = new BlockDataService()
